import {v4 as uuidv4} from "uuid";

const FIRST_JOINED_FROM_KEY = "firstJoinedFrom"

const SESSION_ID_KEY = "sessionId"

export function setFirstJoinedFromIfNotExists(firstJoinedFrom: string): void {
    const previous = getFirstJoinedFrom();

    if (!previous) {
        localStorage.setItem(FIRST_JOINED_FROM_KEY, firstJoinedFrom);
    }
}

export function getFirstJoinedFrom(): string | null {
    return localStorage.getItem(FIRST_JOINED_FROM_KEY);
}

/**
 * Get sessionId from cookie
 */
function getSessionIdFromCookie(): string | null {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [key, value] = cookie.trim().split('=');
        if (key === SESSION_ID_KEY) {
            return value;
        }
    }
    return null;
}

export function generateSessionIdIfNotExists() {
    // First check cookie (set by Lambda@Edge)
    const cookieSessionId = getSessionIdFromCookie();
    if (cookieSessionId) {
        // Store it in localStorage for consistency
        localStorage.setItem(SESSION_ID_KEY, cookieSessionId);
        return;
    }

    // Then check localStorage
    const localSessionId = localStorage.getItem(SESSION_ID_KEY);
    if (!localSessionId) {
        // Generate new sessionId if neither cookie nor localStorage has it
        localStorage.setItem(SESSION_ID_KEY, uuidv4());
    }
}

export function getSessionId() {
    // First check cookie (set by Lambda@Edge)
    const cookieSessionId = getSessionIdFromCookie();
    if (cookieSessionId) {
        return cookieSessionId;
    }

    // Fallback to localStorage
    return localStorage.getItem(SESSION_ID_KEY);
}

export async function sessionIdLoader({request}: { request: Request }): Promise<any> {
    generateSessionIdIfNotExists();
    return null
}